/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import CustomButton from 'components/common/custom-button';
import Loading from 'components/common/loading/Loading';
import ChatLog from 'components/support/detail-tickets/chat-log/ChatLog';
import IssueChat from 'components/support/detail-tickets/issue-chat/IssueChat';
import DetailIssueNotes from 'components/support/detail-tickets/issue-notes/DetailIssueNotes';
import DetailStaffNotes from 'components/support/detail-tickets/staff-notes/DetailStaffNotes';
import {
  ADD_A_NOTE,
  ADD_STAFF_NOTES,
  ADD_TICKET_REPLY,
  CLOSE_TICKET,
  LOGIN_TO_PORTAL,
} from 'components/support/queries';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { Icon } from 'semantic-ui-react';
import { CustomHook } from 'utils/custom-hook';
import * as Styles from './DetailViewAllTickets.styles';
import DevLiveButton from 'components/support/components/DevLiveButton';
import { H5, H6 } from 'utils/resuable-css';
import { Base64 } from 'js-base64';

const DetailViewAllTickets = () => {
  let id = location?.hash?.split('s/')[1];
  const { mutationProps } = CustomHook();
  const [isOpenModal, setIsModal] = useState(false);
  const [isOpenStaffModal, setIsStaffModal] = useState(false);
  const closeNoteModal = () => setIsModal(!isOpenModal);
  const closeStaffNoteModal = () => setIsStaffModal(!isOpenStaffModal);
  const { data, isLoading, refetch: refetchReply } = useQuery(`/admin/tickets/${id}`);
  const {
    data: notesData,
    isFetching: notesLoading,
    refetch: refetchTicketNotes,
  } = useQuery(`/admin/tickets/notes?filter_by=notes:${id}`);
  const {
    data: staffNotes,
    isFetching: loadingStaffNotes,
    refetch: refetchStaffNotes,
  } = useQuery(`/admin/staff/notes?filter_by=ticket:${id}`);
  const { mutate: addReply, isLoading: addReplyLoading } = useMutation(ADD_TICKET_REPLY);
  const { mutate: loginToPortal, isLoading: loadingUrl } = useMutation(LOGIN_TO_PORTAL);
  const { mutate: addNotes, isLoading: addNotesLoading } = useMutation(ADD_A_NOTE);
  const { mutate: ticketClosed, isLoading: loadingTicketClosed } = useMutation(CLOSE_TICKET);
  const { mutate: addStaffNotes, isLoading: addStaffNotesLoading } = useMutation(ADD_STAFF_NOTES);

  useEffect(() => {
    setInterval(() => {
      refetchTicketNotes();
    }, 30 * 1000);
  }, []);

  const handlePortalLogin = async (portal, user) => {
    await loginToPortal(
      {
        portal: portal,
        user: user,
      },
      {
        onSuccess: (e) => {
          window.open(e.redirect_url, '_blank');
        },
      },
    );
  };

  const addTicketNotes = async (id, text) => {
    await addNotes(
      {
        ticketId: id,
        notetxt: btoa(text),
      },
      mutationProps(() => {}, {
        onSuccess: async () => {
          closeNoteModal();
          await refetchTicketNotes();
        },
      }),
    );
  };

  const handleAddStaffNotes = async (summarytext, date, schDate) => {
    await addStaffNotes(
      {
        ticket_reference: id,
        note: btoa(summarytext),
        when: date,
        scheduled_date: date === 'later' ? moment(schDate).format('YYYY-MM-DD HH:mm:ss') : '',
      },
      mutationProps(() => {}, {
        onSuccess: async () => {
          closeStaffNoteModal();
          await refetchStaffNotes();
        },
      }),
    );
  };

  const handleAddReply = async (message, secret, onSuccess) => {
    await addReply(
      {
        action: 'reply',
        ticket_id: id,
        message: Base64.encode(message),
        secret: secret === '' ? '' : btoa(secret),
      },
      mutationProps(() => {}, {
        onSuccess: async () => {
          await refetchReply();
          onSuccess && onSuccess();
        },
      }),
    );
  };

  const handleTicketClosed = async (action, summary) => {
    await ticketClosed(
      {
        summarytxt: btoa(summary),
        ticketId: id,
        actiontxt: action,
      },
      mutationProps(() => {}, {
        onSuccess: async () => {
          await refetchReply();
          await refetchTicketNotes();
        },
      }),
    );
  };

  return isLoading ? (
    <Loading />
  ) : data?.tickets?.length > 0 ? (
    <Styles.BgLogin>
      <Styles.FlexFirst>
        <div className="ticketAndusername">
          <H6>
            Ticket {id}, user {data?.tickets[0]?.username}
          </H6>
        </div>
        <Styles.Buttons>
          <DevLiveButton
            isLoading={loadingUrl}
            title1={`dev`}
            title2={`live`}
            onClickRoute={(route) => handlePortalLogin(route, data.tickets[0].username)}
          />
          <CustomButton
            isLoading={false}
            title={`Client's products`}
            buttonStyles={{ marginRight: '10px', marginTop: '10px' }}
          />
          <CustomButton
            isLoading={false}
            title={`Add note`}
            buttonStyles={{ marginTop: '10px', marginRight: '10px' }}
            onClick={() => closeNoteModal()}
          />
          <CustomButton
            isLoading={false}
            title={`Add staff note`}
            buttonStyles={{ marginTop: '10px' }}
            onClick={() => closeStaffNoteModal()}
          />
        </Styles.Buttons>
      </Styles.FlexFirst>

      <Styles.FirstStep>
        <Styles.TwoWindows>
          <DetailIssueNotes
            notesData={notesData}
            notesLoading={notesLoading}
            addTicketNotes={addTicketNotes}
            addNotesLoading={addNotesLoading}
            ticket={data}
            closeNoteModal={closeNoteModal}
            isOpenModal={isOpenModal}
          />
          <DetailStaffNotes
            staffNotes={staffNotes}
            loadingStaffNotes={loadingStaffNotes}
            closeStaffNoteModal={closeStaffNoteModal}
            isOpenStaffModal={isOpenStaffModal}
            addStaffNotesLoading={addStaffNotesLoading}
            handleAddStaffNotes={handleAddStaffNotes}
            ticketID={id}
          />
        </Styles.TwoWindows>
        {(data?.tickets[0]?.status === '0' ||
          data?.tickets[0]?.vip === '1' ||
          (data?.tickets[0]?.paid === '1' && data?.tickets[0]?.status !== '0')) && (
          <Styles.Errors>
            {data?.tickets[0]?.status === '0' ? (
              <Styles.PurpleError>
                <Icon name="warning circle" />
                <H6>This ticket is now closed</H6>
              </Styles.PurpleError>
            ) : (
              data?.tickets[0]?.vip === '1' && (
                <Styles.GreenError>
                  <Icon name="warning circle" />
                  <H6>This customer is a VIP customer! Urgent response required!</H6>
                </Styles.GreenError>
              )
            )}
            {data?.tickets[0]?.paid === '1' && data?.tickets[0]?.status !== '0' && (
              <Styles.GreenError>
                <Icon name="warning circle" />
                <H6> This customer has paid support! Urgent response requried!</H6>
              </Styles.GreenError>
            )}
            {/* <Styles.RedError>
            <Icon name="warning circle" />
            <p>This customer is currently due or account is suspended or a virtual server is suspended.</p>
          </Styles.RedError> */}
          </Styles.Errors>
        )}
      </Styles.FirstStep>
      <Styles.SecondStep>
        <IssueChat
          isHaveStaffNotes={staffNotes?.count}
          loadingTicketClosed={loadingTicketClosed}
          handleTicketClosed={handleTicketClosed}
          getTicketsDetail={data}
          handleAddReply={handleAddReply}
          addReplyLoading={addReplyLoading}
        />
      </Styles.SecondStep>
      <Styles.ChatLogContainer>
        <Styles.WidthDiv />
        <Styles.Content>
          <Styles.Heading>
            <Icon name="user" />
            <H5 className="heading">Ticket Log</H5>
          </Styles.Heading>
          <ChatLog chatLog={data} />
        </Styles.Content>
      </Styles.ChatLogContainer>
    </Styles.BgLogin>
  ) : (
    <Styles.TicketNotFound>Ticket not found</Styles.TicketNotFound>
  );
};

export default DetailViewAllTickets;
